angular.module('callX').controller('IntegrationsGoogleAdwordsCtrl', ['$scope', '$window', 'GoogleAdwordsService', '$stateParams', 'toaster', 'UserService', '$state', 'DateService', '$auth', 'SatellizerConfig','$location', function($scope,$window, GoogleAdwordsService, $stateParams, toaster, UserService, $state, DateService, $auth, SatellizerConfig,$location) {


    $scope.loadingDetailsContent = false;
    //$scope.data1 = {"status":"success","title":"Success","data":[{"id":1,"customer_account_detail":{"id":1,"customer_id":4068912976,"publisher_id":30,"currency_code":"INR","date_time_zone":"Asia/Calcutta","descriptive_name":"callx test","company_name":"","can_manage_clients":true,"test_account":true,"auto_tagging_enabled":false,"tracking_url_template":null,"created_at":"2017-02-21 13:03:33","updated_at":"2017-02-21 13:03:33"},"client_id":1315245891,"publisher_id":30,"name":"callx campaign","can_manage_clients":false,"currency_code":"INR","date_time_zone":"Asia/Calcutta","test_account":true,"exclude_hidden_accounts":null,"created_at":"2017-02-21 13:03:34","updated_at":"2017-02-21 13:03:34"},{"id":2,"customer_account_detail":{"id":2,"customer_id":4068912976,"publisher_id":30,"currency_code":"INR","date_time_zone":"Asia/Calcutta","descriptive_name":"callx test","company_name":"","can_manage_clients":true,"test_account":true,"auto_tagging_enabled":false,"tracking_url_template":null,"created_at":"2017-02-23 06:39:25","updated_at":"2017-02-23 06:39:25"},"client_id":1315245892,"publisher_id":30,"name":"callx swaroop campaign","can_manage_clients":false,"currency_code":"INR","date_time_zone":"Asia/Calcutta","test_account":true,"exclude_hidden_accounts":null,"created_at":"2017-02-23 06:39:26","updated_at":"2017-02-23 06:39:26"},{"id":3,"customer_account_detail":{"id":3,"customer_id":4068912976,"publisher_id":30,"currency_code":"INR","date_time_zone":"Asia/Calcutta","descriptive_name":"callx test","company_name":"","can_manage_clients":true,"test_account":true,"auto_tagging_enabled":false,"tracking_url_template":null,"created_at":"2017-02-23 07:59:27","updated_at":"2017-02-23 07:59:27"},"client_id":1315245893,"publisher_id":30,"name":"callx chandan campaign","can_manage_clients":false,"currency_code":"INR","date_time_zone":"Asia/Calcutta","test_account":true,"exclude_hidden_accounts":null,"created_at":"2017-02-23 07:59:27","updated_at":"2017-02-23 07:59:27"}],"statusCode":200};
    //$scope.customerIdDataNumber =  $scope.data1.data;
    $scope.currentUserData = UserService.getCurrentUserData();
    $scope.orderParam = '';
    $scope.showAuthorizeForm = 0;
    $scope.customerId = {};
    $scope.companyName = {};
    $scope.tableContentLoading = false;
    $scope.noData = false;

    $scope.userOrderParam = 'revenue';
    $scope.userReverse = true;
    $scope.usersOrder = function(orderParam) {
        $scope.userReverse = ($scope.userOrderParam === orderParam) ? !$scope.userReverse : false;
        $scope.userOrderParam = orderParam;
    };
    $scope.customerIdSelected = function(customerId){
        $scope.companyNameFiltered = [];
        if (!$scope.customerId.selected) return;
        var selectedCustomerId = customerId.client_id;
        for( var i = 0; i < $scope.customerIdDataNumber.length; i++ ) {
            if($scope.customerIdDataNumber[i].client_id == selectedCustomerId) {
                $scope.companyNameFiltered.push($scope.customerIdDataNumber[i]);
                //console.log($scope.companyNameFiltered,"this is the selected customer id")
            }
        }
        
    };
    //AdWords Promo Number & Confirmed Account Number
    $scope.getConfirmedAccountPromoNumbers  = function(){
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                $scope.confirmedClientId = data.data.customer_account_access_detail.selected_client_customer_id;
                $scope.confirmedClientName = data.data.customer_account_access_detail.selected_client_company_name;
                if(data.data.campaign_promo_numbers){
                $scope.accountPromoNumbers = data.data.campaign_promo_numbers;
                $scope.tableContentLoading = false;
                $scope.noData = false;
                }else{
                    $scope.noData = true;
                    $scope.tableContentLoading = false;
                }
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        GoogleAdwordsService.getPromoNumbers($scope.currentUserData.id, callbacks);
    };

    //AdWords Accounts List
    $scope.getCustomerId = function(){
        var callbacks = {
            success: function (data) {
                $scope.customerIdDataNumber =  data.data;
            },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
         GoogleAdwordsService.getCustomerId($scope.currentUserData.id,callbacks);
    };

    var getPublisherStatus = function(){
        var callbacks = {
            success: function(data) {
                $scope.publisherStatus = data.data;
                // if($scope.publisherStatus.authenticate == 'true'){
                //    $state.go('app.integrations.google-adwords-activation');
                // }
                if($scope.publisherStatus.authenticate == true && $scope.publisherStatus.confirm == false && $scope.publisherStatus.status == 'approved' ){
                    $state.go('app.integrations.google-adwords-activation');
                    $scope.getCustomerId();
                    //console.log("called after state go in true and false")

                }
                if($scope.publisherStatus.confirm == true && $scope.publisherStatus.authenticate == true && $scope.publisherStatus.status == 'approved'){
                    $state.go('app.integrations.google-adwords-promo-numbers');
                    $scope.getConfirmedAccountPromoNumbers();
                    //console.log("called after state go in all true")
                }
                if(($scope.publisherStatus.status == 'not active' || $scope.publisherStatus.status == 'deactivate') && ($scope.publisherStatus.authenticate == false) && ($scope.publisherStatus.authenticate == false)){
                   //console.log("3rd if condition")
                   $state.go('app.integrations.google-adwords');
                }
                if(($scope.publisherStatus.status == 'pending') && ($scope.publisherStatus.authenticate == false) && ($scope.publisherStatus.authenticate == false)){
                    //console.log("4th if condition")
                   $state.go('app.integrations.google-adwords');
                }
                if(($scope.publisherStatus.status == 'approved') && ($scope.publisherStatus.authenticate == false) && ($scope.publisherStatus.authenticate == false)){
                    //console.log("5th if condition")
                   $state.go('app.integrations.google-adwords');
                }
                //console.log(data,"this is publisher status data")
            },
            failure: function(data) {
                $scope.loadingDetailsContent = false;
            }
        };
        GoogleAdwordsService.getPublisherStatus($scope.currentUserData.id, callbacks);
    };

    if($scope.currentUserData.id != undefined){
        getPublisherStatus();
    }

    $scope.$on('currentUserUpdate', function(event, currentUserData) {
        $scope.currentUserData = currentUserData;
        getPublisherStatus();
    });
    
    var accessURLData = function(){
        var callbacks = {
            success: function(data) {
                $scope.accessURLData = data.data;
                //console.log($scope.accessURLData,"this is acess url")
            },
            failure: function(data) {
                $scope.loadingDetailsContent = false;
            }
        };
        GoogleAdwordsService.getAccessURL(callbacks);
    };
    accessURLData();

    //Authorize
    $scope.showAuthorizeText = function(){
        $scope.showAuthorizeForm = 1;
    };


    // $scope.reverse = true;
    // $scope.order = function(orderParam) {
    //     $scope.reverse = ($scope.orderParam === orderParam) ? !$scope.reverse : false;
    //     $scope.orderParam = orderParam;
    // };
    //Confirm AdWord Account
    $scope.confirmAdwordAccount = function(){
         var callbacks = {
            success: function (data) {
                //$state.go("app.integrations.google-adwords-promo-numbers");
                getPublisherStatus();
                toaster.pop('success', 'Success', 'Successfully confirmed Google Adwords account', 2000);
                //$scope.getConfirmedAccountPromoNumbers();
            },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
         GoogleAdwordsService.confirmAccount($scope.currentUserData.id, $scope.companyNameFiltered[0].id,callbacks);
    };

    //Delete AdWord Account
    $scope.deleteAdwordAccount = function(){
         var callbacks = {
            success: function (data) {
                getPublisherStatus();
                toaster.pop('success', 'Success', 'Successfully deleted Google Adwords account', 2000);
                
            },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
         GoogleAdwordsService.deleteAccount($scope.currentUserData.id,callbacks);
    };

    //Activate AdWord Request
    $scope.activateRequest = function(){
        var callbacks = {
            success: function (data) {
                getPublisherStatus();
                toaster.pop('success', 'Success', 'Successfully applied to Google Adwords', 2000);
                $scope.activateResponse = data.data.status;
            },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
         GoogleAdwordsService.activatePublisher($scope.currentUserData.id, {'status':'apply'},callbacks);
    };

    $scope.getCustomerData = function(){
        var callbacks = {
            success: function (data) {
                $scope.customerId = data;
                $scope.getCustomerId();
                //console.log($scope.customerId,"this is the customer info")
            },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
         GoogleAdwordsService.getCustomerId($scope.currentUserData.id,callbacks);

    };

    //Authorize with google
    $scope.goToGoogleOAuth = function(){
        SatellizerConfig.providers.google.url = "/japi/adwords/generate/refresh/token/"+$scope.currentUserData.id;
        SatellizerConfig.providers.google.redirectUri = $scope.accessURLData.redirect_uri;
        SatellizerConfig.providers.google.accessType = $scope.accessURLData.access_type;
        SatellizerConfig.providers.google.approvalPrompt = $scope.accessURLData.approval_prompt;
        SatellizerConfig.providers.google.scope = $scope.accessURLData.scope;
        SatellizerConfig.providers.google.responseType = $scope.accessURLData.response_type;

        $auth.authenticate('google')
            .then(function(response) {
                getPublisherStatus();
                $scope.getCustomerId();
                $scope.showSuccessAlert = true;
            })
            .catch(function(response) {
            });

    };

    $scope.saveUserDetails = function(promoId,status){
        var index = -1;
        for(var j=0; j<$scope.accountPromoNumbers.length; j++){
            if($scope.accountPromoNumbers[j].id == promoId){
                index = j;
                break;
            }
        }
        var adwords_access_status;
        if(status){
            adwords_access_status = true;
        }else{
            adwords_access_status = false;
        }
        // var google_adwords_access_status;
        // if($scope.accountPromoNumbers[index].lead_access_granted != googleAdWordsAccess){
        //     if(googleAdWordsAccess){
        //         google_adwords_access_status = 'approved';
        //     }
        //     if(!googleAdWordsAccess){
        //         google_adwords_access_status = 'deactivate';
        //     }
        // }

        $scope.accountPromoNumbers[index].isSavingDescription = true;
        var callbacks = {
            success: function (data) {
                $scope.accountPromoNumbers[index].editContainer = false;
                $scope.accountPromoNumbers[index].isSavingDescription = false;
                toaster.pop('success', 'Success', 'Promo number integration updated', 2000);
                getPublisherStatus();
                $scope.getConfirmedAccountPromoNumbers();
                //$scope.accountPromoNumbers[index].google_adwords_access_granted = (data.data.status == 'approved');
                
            },
            failure: function (data) {
                $scope.accountPromoNumbers[index].editContainer = false;
                $scope.accountPromoNumbers[index].isSavingDescription = false;
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                getPublisherStatus();
                $scope.getConfirmedAccountPromoNumbers();
            }
        };
        GoogleAdwordsService.savePromoNumber(promoId, {'approved':adwords_access_status}, callbacks);
    };

    $scope.goToGoogleAccountDelete = function(){
        $scope.deleteAdwordAccount();
    };

    $scope.goAccountDelete = function(){
        $scope.deleteAdwordAccount();
    };
    $scope.getPromoNumberData = function(promoNumber){
        var currentUserId = UserService.getCurrentUserData();
//        console.log(currentUserId,"this is customerId")
        $state.go('app.integrations.google-adwords-promo-numbers-reports', { 'userId': currentUserId.id, 'sid': promoNumber });
    };

    $scope.closeAlert = function(index) {
        $scope.showSuccessAlert = false;
    };


    $scope.goBack = function(){
        window.history.back();
    }


}]);